import React from 'react';
import { Fuel, Globe, Instagram, Mail, Smartphone } from 'lucide-react';

const columns = [
  {
    heading: 'Aplicativo',
    links: [
      { label: 'Funcionalidades', href: '#funcionalidades' },
      { label: 'Screenshots', href: '#screenshots' },
      { label: 'Download', href: '#download' },
      { label: 'Novidades', href: '#' },
    ],
  },
  {
    heading: 'Empresa',
    links: [
      { label: 'Sobre', href: '/sobre' },
      { label: 'Blog', href: '/blog' },
      { label: 'Contato', href: 'mailto:contato@gas2.app' },
      { label: 'Imprensa', href: '#' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Privacidade', href: '/privacidade' },
      { label: 'Termos de uso', href: '/termos' },
      { label: 'Cookies', href: '#' },
      { label: 'LGPD', href: '#' },
    ],
  },
];

const socialLinks = [
  { icon: Instagram, href: 'https://instagram.com', label: 'Instagram' },
  { icon: Globe, href: 'https://gas2.app', label: 'Website' },
  { icon: Mail, href: 'mailto:contato@gas2.app', label: 'E-mail' },
];

// Constrói o href do canal do WhatsApp incluindo UTMs e referenciador do site
const buildWhatsAppHref = (source = 'footer') => {
  const base = 'https://whatsapp.com/channel/0029VbCYZ2TFi8xhMTsye51K';
  const separator = base.includes('?') ? '&' : '?';
  return `${base}${separator}utm_source=${encodeURIComponent(source)}&utm_medium=referral&utm_campaign=radar_gas2&utm_content=whatsapp_channel&ref=gas2.app`;
};

// Adiciona WhatsApp aos links sociais (abrir em nova aba)
socialLinks.push({ icon: Smartphone, href: buildWhatsAppHref('footer'), label: 'WhatsApp' });

// Footer com quatro colunas desktop e links organizados por categoria
const Footer: React.FC = () => (
  <footer className="bg-gray-900 text-gray-400">
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
      <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
        {/* Identidade da marca */}
        <div className="lg:col-span-1">
          <a href="/" className="mb-4 inline-flex items-center gap-2 text-xl font-bold text-white">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-amber-400">
              <Fuel className="h-5 w-5 text-gray-900" strokeWidth={2} />
            </span>
            Gas2
          </a>
          <p className="max-w-[220px] text-sm leading-relaxed text-gray-400">
            Controle total do seu veículo, na palma da mão. Para motoristas e pequenas frotas.
          </p>
          <div className="mt-5 flex items-center gap-2">
            {socialLinks.map(({ icon: Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target={href.startsWith('http') ? '_blank' : undefined}
                rel={href.startsWith('http') ? 'noreferrer noopener' : undefined}
                aria-label={label}
                className="flex h-9 w-9 items-center justify-center rounded-lg bg-gray-800 text-gray-400
                  transition-colors duration-200 hover:bg-amber-400 hover:text-gray-900"
              >
                <Icon className="h-4 w-4" strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>

        {/* Colunas de links */}
        {columns.map((col) => (
          <div key={col.heading}>
            <h4 className="mb-4 text-sm font-semibold text-white">{col.heading}</h4>
            <ul className="space-y-2.5">
              {col.links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm transition-colors duration-200 hover:text-amber-400"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Rodapé inferior */}
      <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-gray-800 pt-7 text-xs text-gray-500 sm:flex-row">
        <p>Copyright &copy; 2026 Marcus Duarte &mdash; Gas2. Todos os direitos reservados.</p>
        <p>Feito com ❤️ no Brasil 🇧🇷</p>
      </div>
    </div>
  </footer>
);

export default Footer;


